<template>
  <div class="hero-carousel">
    <div class="carousel">
      <div class="carousel-container">
        <div
          class="carousel-item"
          :style="{cursor: !indexBanner.link?'default':'pounter'}"
          v-for="(item, index) in indexBanner"
          v-bind:key="index"
        >
          <router-link :to="{ path: indexBanner.link?generateRouteUrl(item):'' }">
          <picture>
            <img :src="replaceBigCoverImage(item.image)" alt="" />
          </picture>
          </router-link>
        </div>
        <!-- <div
          class="carousel-item">
        <picture>
            <source
              srcset="@/scss/img/hero-carousel-item-s.jpg"
              media="(max-width: 767px)"
            />
            <source
              srcset="@/scss/img/hero-carousel-item-m.jpg"
              media="(max-width: 1023px)"
            />
            <source
              srcset="@/scss/img/hero-carousel-item-sl.jpg"
              media="(max-width: 1279px)"
            />
            <img src="@/scss/img/hero-carousel-item.jpg" alt="" />
          </picture>
        </div> -->
      </div>
      <div v-if="indexBanner.lenth > 1" class="carousel-dots">
        <span
          v-for="(item, index) in indexBanner"
          :key="item.id"
          :class="{ active: step === index }"
          @click.prevent="setStep(index)"
        >
        </span>
      </div>
      <div class="carousel-nav" v-if="indexBanner.lenth > 1">
        <svg
          width="55"
          height="55"
          id="carousel-nav-prev"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click.prevent="prevStep"
        >
          <circle
            cx="27.5"
            cy="27.5"
            r="27.5"
            fill="black"
            fill-opacity="0.4"
          />
          <path
            d="M17.9375 26.9375L29.9375 15C30.5 14.375 31.4375 14.375 32.0625 15C32.625 15.5625 32.625 16.5 32.0625 17.0625L21.0625 28L32 39C32.625 39.5625 32.625 40.5 32 41.0625C31.4375 41.6875 30.5 41.6875 29.9375 41.0625L17.9375 29.0625C17.3125 28.5 17.3125 27.5625 17.9375 26.9375Z"
            fill="white"
          />
        </svg>
        <svg
          width="55"
          height="55"
          id="carousel-nav-next"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click.prevent="nextStep"
        >
          <circle
            cx="27.5"
            cy="27.5"
            r="27.5"
            fill="black"
            fill-opacity="0.4"
          />
          <path
            d="M36.0625 26.9375C36.625 27.5625 36.625 28.5 36.0625 29.0625L24.0625 41.0625C23.4375 41.6875 22.5 41.6875 21.9375 41.0625C21.3125 40.5 21.3125 39.5625 21.9375 39L32.875 28.0625L21.9375 17.0625C21.3125 16.5 21.3125 15.5625 21.9375 15C22.5 14.375 23.4375 14.375 24 15L36.0625 26.9375Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import cover from "@/mixins/cover";

export default {
  name: "FirstPageSliderOne",
  data: () => {
    return {
      step: 0,
      carouselPositions: [],
      halfContainer: 0,
      interval: false,
      sliders: []
    };
  },
  mixins: [cover],
  computed: {
    ...mapState("slider", {
      indexBanner: state => {
        return state.index.bannersHomePage;
      },
      indexLoading: state => state.indexLoading
    }),
    ...mapState({
      width: state => state.width,
      height: state => state.height
    }),
    ...mapState("home", {
      indexData: state => state.index.blocks[0].sections[0].items,
      indexLoading: state => state.indexLoading
    })
  },
  created() {
    if (this.FPSOinterval) {
      clearInterval(this.FPSOinterval);
    }
    this.FPSOinterval = setInterval(() => {
      this.nextStep();
    }, 10000);
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    clearInterval(this.FPSOinterval);
  },
  methods: {
    ...mapActions("slider", {
      actionIndex: "index"
    }),
    init() {
      this.$nextTick(() => {
        this.carouselPositions = [];
        this.blockWidth = document.querySelector(".carousel").offsetWidth;

        document.querySelectorAll(".carousel-container picture").forEach(
          function(div, index) {
            this.carouselPositions.push([
              index * this.blockWidth,
              (index + 1) * this.blockWidth // add to array the positions information
            ]); // add to array the positions information
          }.bind(this)
        );
      });
    },
    setStep(step) {
      try {
        this.step = step;
        clearInterval(this.FPSOinterval);
        this.FPSOinterval = setInterval(() => {
          this.nextStep();
        }, 10000);
        let slider = document.querySelector(".carousel-container");
        if (slider) {
          slider.scrollTo({
            left: this.carouselPositions[this.step][0],
            behavior: "smooth"
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    prevStep() {
      if (this.step === 0) {
        this.step = this.carouselPositions.length - 1;
      } else {
        this.step--;
      }
      let slider = document.querySelector(".carousel-container");
      if (slider) {
        slider.scrollTo({
          left: this.carouselPositions[this.step][0],
          behavior: "smooth"
        });
      }
    },
    nextStep() {
      try {
        if (this.carouselPositions.length - 1 === this.step) {
          this.step = 0;
        } else {
          this.step++;
        }
        let slider = document.querySelector(".carousel-container");
        if (slider) {
          slider.scrollTo({
            left: this.carouselPositions[this.step][0],
            behavior: "smooth"
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    scrollSlider() {
      clearInterval(this.FPSOinterval);
      document
        .querySelectorAll(".carousel-container picture")
        .forEach((div, index) => {
          let rect = div.getBoundingClientRect();
          if (rect.left >= 0 && rect.left <= 180) {
            this.step = index;
          }
        });
      this.FPSOinterval = setInterval(() => {
        this.nextStep();
      }, 10000);
    }
  }
};
</script>

<style scoped></style>
